import React from 'react';
import PropTypes from 'prop-types';

function Bell({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M11.557 18.103C11.3988 18.3758 11.1717 18.6023 10.8984 18.7597C10.6251 18.9171 10.3153 19 10 19C9.68466 19 9.37485 18.9171 9.1016 18.7597C8.82834 18.6023 8.60123 18.3758 8.443 18.103M19 14.5024H1C1.71608 14.5024 2.40284 14.2179 2.90919 13.7114C3.41554 13.205 3.7 12.5181 3.7 11.8019V7.30112C3.7 5.62996 4.36375 4.02724 5.54523 2.84555C6.72671 1.66387 8.32914 1 10 1C11.6709 1 13.2733 1.66387 14.4548 2.84555C15.6363 4.02724 16.3 5.62996 16.3 7.30112V11.8019C16.3 12.5181 16.5845 13.205 17.0908 13.7114C17.5972 14.2179 18.2839 14.5024 19 14.5024Z" />
    </svg>
  );
}

Bell.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Bell;
